import React, { useEffect, useRef, useState } from "react";
import { Button } from "@lightspeed/flame/Button";
import { useDispatch } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { autoLogin } from "../../redux/actions/userActions";
import { LoginWrapper } from "../LoginWrapper";

const AutoLogin = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const loginStarted = useRef(false);
  const [message, setMessage] = useState("Signing you in...");
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    if (loginStarted.current) {
      return;
    }

    loginStarted.current = true;
    const params = new URLSearchParams(location.search);
    const token = params.get("token");

    if (!token) {
      setFailed(true);
      setMessage("Auto-login token is missing.");
      return;
    }

    dispatch(autoLogin({ token }))
      .then(() => {
        history.replace("/");
      })
      .catch((err) => {
        console.log(err);
        setFailed(true);
        setMessage("Auto-login link is invalid or expired.");
      });
  }, [dispatch, history, location.search]);

  return (
    <LoginWrapper>
      <div className="auto-login-content">
        <h2>Auto Login</h2>
        <p className={failed ? "form-notifi" : ""}>{message}</p>

        {failed && (
          <Button
            block={false}
            type="button"
            fill={true}
            variant="primary"
            onClick={() => history.replace("/")}
          >
            Back to login
          </Button>
        )}
      </div>
    </LoginWrapper>
  );
};

export default AutoLogin;
